'use client';

import type { FormSchema } from './schema';

import { Form, Icon, Typography } from '@polyseme/design-system';
import { useTranslations } from 'next-intl';
import { useRef } from 'react';
import { useForm } from 'react-hook-form';

import { calculateFamilyBudget } from '~/landing/app/(garance)/cagnup/calculations';
import {
  CtaSection,
  EstimatedSavings,
  FamilyForm,
  SimulationSection,
} from '~/landing/app/(garance)/cagnup/components';

const defaultFamily = {
  middleHighSchoolers: 0,
  schoolChildren: 0,
  universityStudents: 0,
};
const defaultValues = {
  budget: calculateFamilyBudget(defaultFamily),
  family: defaultFamily,
};

export const Client = () => {
  const form = useForm<FormSchema>({
    defaultValues,
  });
  const t = useTranslations('landing.cagnup');

  const familyFormRef = useRef<HTMLDivElement>(null);
  const estimatedSavingsRef = useRef<HTMLDivElement>(null);
  const ctaSectionRef = useRef<HTMLDivElement>(null);

  const scrollToFamilyForm = () =>
    familyFormRef.current?.scrollIntoView({ behavior: 'smooth' });

  const scrollToEstimatedSavings = () =>
    estimatedSavingsRef.current?.scrollIntoView({ behavior: 'smooth' });

  const scrollToCtaSection = () =>
    ctaSectionRef.current?.scrollIntoView({ behavior: 'smooth' });

  return (
    <>
      <Form {...form}>
        <form>
          <FamilyForm
            ref={familyFormRef}
            scrollToEstimatedSavings={scrollToEstimatedSavings}
          />
          <EstimatedSavings
            ref={estimatedSavingsRef}
            scrollToCtaSection={scrollToCtaSection}
            scrollToFamilyForm={scrollToFamilyForm}
          />
          <section className="bg-[#D1FAE5] py-16">
            <div className="mx-auto w-full max-w-screen-2xl space-y-6 px-4 md:px-10">
              <p className="font-secondary text-4xl md:whitespace-pre-wrap md:text-6xl">
                {t('banner.title')}
              </p>
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-between rounded-full bg-emerald-300 p-2.5">
                  <Icon name="arrow-right" />
                </div>
                <Typography className="font-semibold">
                  {t('banner.subtitle')}
                </Typography>
              </div>
            </div>
          </section>
          <SimulationSection />
        </form>
      </Form>
      <CtaSection ref={ctaSectionRef} />
    </>
  );
};
